module.exports = __webpack_public_path__ + "media/images/icons/twotone/file-exclamation-4e25f8a82e8161898db0228ad88aa4f9.svg";